exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group-item {\n  -ms-flex-pack: unset !important;\n      justify-content: unset !important;\n  padding: 0.5rem 20% !important; }\n\n.list-group.collapsed {\n  width: 150px; }\n\n.text-submenu {\n  margin-left: 20px;\n  font-size: smaller; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/navigation/options/usuarios/usuarios-submenu/usuarios-submenu.component.scss
// module id = ../../../../../src/app/components/navigation/options/usuarios/usuarios-submenu/usuarios-submenu.component.scss
// module chunks = main